import pluralize from 'pluralize'

// Encapsulates payload in JSONAPI compliant structure
const dataFormat = (type, payload) => {
  return {
    data: {
      type: type,
      attributes: payload
    }
  }
}

const makePlural = (value) => {
  return pluralize(value)
}

export default {
  dataFormat,
  makePlural
}
